import BannerImages from '../../components/BannerImage/BannerImages';
import UpdateScrollingText from '../../components/UpdateScrollingText/UpdateScrollingText';
import UpcomingExams from '../../components/UpcomingExam/UpcomingExam';
import Notifications from '../../components/Notification/Notification';
import Classes from '../../components//Classes/Classes';
import StudentFeedbacks from '../../components/StudentFeedbacks/StudentFeedbacks';
// import UpdateStatsComponent from '../../components/Stats';
import Stats from '../../components/Stats/Stats';
import Services from '../Services/Services';
import Activities from '../../components/Activities/Activities';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Homepage.css';
import API_URL from '../../api/ExamCalendarApi';

const HomePage = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API_URL}/homepage/all`)
      .then((response) => {
        // Sort entries in descending order based on timestamp
        const homepagedata = response.data;
        // console.log(homepagedata)
        
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, [API_URL]);

  return (
    <div className='admin-homepage-container'>
      <div className='admin-homepage-section'>
        <BannerImages />
      </div>
      <div className='admin-homepage-section'>
        <UpdateScrollingText />
      </div>
      <div className='admin-homepage-section'>
        <UpcomingExams />
      </div>
      <div className='admin-homepage-section'>
        <Notifications />
      </div>
      <div className='admin-homepage-section'>
        <Classes />
      </div>
      <div className='admin-homepage-section'>
        <StudentFeedbacks />
      </div>
      <div className='admin-homepage-section'>
        <Stats />
      </div>
      <div className='admin-homepage-section'>
        <Services />
      </div>
      <div className='admin-homepage-section'>
        <Activities />
      </div>
    </div>
  );
};

export default HomePage;
